import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ResendRequest } from './resend.model';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ResendService {
  constructor(private http: HttpClient) {}

  resendPolicy(resendRequest: ResendRequest, ePolicyId: number): Observable<any> {
    const url = `${environment.endpoint.epolicyAPI}/${ePolicyId}`;

    return this.http.put(url, resendRequest).pipe(catchError((error: Error) => throwError(() => error)));
  }
}
